let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36y9m")).then(() => parcelRequire('60RsL'));